export const COMPONENTS_TO_MOVE_TO_HIDDEN_CANVAS = [
  'LocalDialogSymbol',
  'BuilderComponentsSnackBar',
];
export const BUILDER_COMPONENTS_ROUTE_LAYOUT = 'BuilderComponentsRouteLayout';
export const ROOT = 'root';
